import { act, useEffect, useState } from "react";
import IconClose from "../icons/IconClose";

export default function Message({
  type = "message",
  isInline = false,
  message,
  details,
  onClosed = () => {},
}) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setActive(true);
    }, 250);
  }, []);

  return (
    <div
      className={`message ${
        active && "active"
      } flex flex-direction-column flex-gap-xs padding-bottom-xs padding-top-xs padding-left-s padding-right-l ${
        isInline === false
          ? "fixed width-fit-content"
          : "text-center border-none"
      } ${type}`}
    >
      <div
        className="message-close"
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            onClosed();
          }, 250);
        }}
      >
        <IconClose />
      </div>
      {message && <div className="message-main">{message}</div>}
      {details && <div className="message-details">{details}</div>}
    </div>
  );
}
